/* CUSTOM:START VariantDeliveryMessaging */
class VariantDeliveryMessaging {
    static async init() {
        this.variantsData = {};
        this.selectedVariant = null;
        this.countdownInterval = null;

        try {
            const liquidData = JSON.parse(
                document.getElementById('variant-delivery-messaging__variants_data').textContent
            );
            this.variantsData = liquidData.variants;
            this.selectedVariant =
                this.variantsData[liquidData.selected_or_first_available_variant] || null;

            document.addEventListener(
                'on:variant:change',
                this.onVariantChange.bind(this)
            );

            document.addEventListener('click', (e) => {
                const el = e.target.closest('[data-action="vdm-change-zip"]');
                if (!el) return;
                e.preventDefault();
                VariantDeliveryMessaging.promptForClientZip();
            });
        } catch (e) {
            console.error(e);
        }

        await this.generateDeliveryMessaging();
    }

    static async onVariantChange(evt) {
        const variantId = evt.detail?.variant?.id;
        this.selectedVariant = this.variantsData[variantId] || null;
        await this.generateDeliveryMessaging();
    }

    static async promptForClientZip() {
        const zip = prompt(
            'Enter your zip code',
            localStorage.getItem('syl_user_zip') || ''
        );
        if (zip !== null) {
            await this.updateClientZip(zip);
        }
    }

    static async updateClientZip(zip) {
        const usZipRegex = /^\d{5}(?:[-\s]\d{4})?$/;
        const caPostalRegex =
            /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJKLMNPRSTVWXYZ][ -]?\d[ABCEGHJKLMNPRSTVWXYZ]\d$/i;

        if (!usZipRegex.test(zip) && !caPostalRegex.test(zip)) {
            alert('Please enter a valid US ZIP or Canadian postal code');
            return;
        }

        if (localStorage.getItem('syl_user_zip') === zip) return;

        localStorage.setItem('syl_user_zip', zip);
        await this.generateDeliveryMessaging();
    }

    static async generateDeliveryMessaging() {
        if (this.countdownInterval) {
            clearInterval(this.countdownInterval);
            this.countdownInterval = null;
        }

        const stockMessageEl = document.getElementById(
            'variant-delivery-messaging__stock_message'
        );
        const freeDeliveryMessageEl = document.getElementById(
            'variant-delivery-messaging__free_delivery_message'
        );

        let stockMessageHTML;
        let freeDeliveryMessageHTML;

        try {
            if (stockMessageEl) stockMessageEl.innerHTML = '';
            if (freeDeliveryMessageEl) freeDeliveryMessageEl.innerHTML = '';

            this.selectedVariant.is_preorder =
                this.selectedVariant.available && this.selectedVariant.is_preorder;

            freeDeliveryMessageHTML =
                `Free ${this.selectedVariant.ships_freight ? 'Freight' : 'Standard'} Delivery` +
                `${this.selectedVariant.price < 45 ? ' on orders over $45' : ''}`;

            /* --------------------------------------------------
             * Hard stops (no worker)
             * -------------------------------------------------- */
            if (this.selectedVariant.is_discontinued) {
                stockMessageHTML = 'This product is discontinued.';
                freeDeliveryMessageHTML = undefined;
            } else if (this.selectedVariant.available === false) {
                stockMessageHTML = 'This item is currently Out of Stock.';
                freeDeliveryMessageHTML = undefined;
            } else {
                /* --------------------------------------------------
                 * Worker call (normal + dropship + preorder)
                 * -------------------------------------------------- */
                let workerData = null;

                try {
                    const debugCurrentDateTime =
                        new URL(window.location.href).searchParams.get(
                            'debugCurrentDateTime'
                        );
                    const now = debugCurrentDateTime
                        ? new Date(debugCurrentDateTime)
                        : new Date();

                    const response = await fetch(
                        'https://syl-shipping-offer-worker.sylvane-discountbandit7106.workers.dev',
                        {
                            method: 'POST',
                            headers: { 'Content-Type': 'application/json' },
                            body: JSON.stringify({
                                variantId: this.selectedVariant.id,
                                zip:
                                    localStorage.getItem('syl_user_zip') ||
                                    undefined,
                                currentDateTime: debugCurrentDateTime
                                    ? now.toISOString()
                                    : undefined,
                            }),
                        }
                    );

                    const responseData = await response.json();

                    if (!responseData.success) {
                        if (
                            responseData.error === 'Provided zip is invalid' ||
                            responseData.error ===
                                'Provided postal code is invalid'
                        ) {
                            localStorage.removeItem('syl_user_zip');
                        }
                        throw new Error(
                            responseData.error || 'Unknown Error'
                        );
                    }

                    workerData = responseData.data;

                    if (
                        workerData.zip &&
                        localStorage.getItem('syl_user_zip') !== workerData.zip
                    ) {
                        localStorage.setItem(
                            'syl_user_zip',
                            workerData.zip
                        );
                    }

                    const { eligibility } = workerData;

                    if (eligibility?.status === 'blocked') {
                        const zip =
                            localStorage.getItem('syl_user_zip');

                        stockMessageHTML = `
                            <div class="shipping-warning">
                                <strong>Shipping restriction</strong><br>
                                ${eligibility.reason}
                                <div class="shipping-warning__cta">
                                    <a href="#" data-action="vdm-change-zip">
                                        ${
                                            zip
                                                ? `Not shipping to <b>${zip}</b>? Click to update`
                                                : 'Enter ZIP code'
                                        }
                                    </a>
                                </div>
                            </div>
                        `;

                        freeDeliveryMessageHTML = undefined;

                        if (stockMessageEl && stockMessageHTML) {
                            stockMessageEl.innerHTML =
                                stockMessageHTML;
                        }
                        return;
                    }
                } catch (e) {
                    console.error(
                        '[variant-delivery-messaging] Worker error:',
                        e
                    );
                }

                /* --------------------------------------------------
                 * Presentation logic (eligibility already allowed)
                 * -------------------------------------------------- */
                if (this.selectedVariant.is_dropship) {
                    stockMessageHTML =
                        `<span class="in-stock-indicator">In Stock</span>`;

                    const d = this.selectedVariant.dship_lead_time;
                    if (d >= 21)
                        stockMessageHTML +=
                            `<strong> Usually ships in 4 to 6 weeks.</strong>`;
                    else if (d >= 20)
                        stockMessageHTML +=
                            `<strong> Usually ships in a month.</strong>`;
                    else if (d >= 15)
                        stockMessageHTML +=
                            `<strong> Usually ships in 2 to 3 weeks.</strong>`;
                    else if (d >= 10)
                        stockMessageHTML +=
                            `<strong> Usually ships in 2 weeks.</strong>`;
                    else if (d >= 6)
                        stockMessageHTML +=
                            `Usually ships in a week.`;
                    else if (d >= 4)
                        stockMessageHTML +=
                            `Usually ships in 3 to 5 business days.`;
                    else if (d >= 3)
                        stockMessageHTML +=
                            `Usually ships in 2 to 3 business days.`;
                    else if (d >= 2)
                        stockMessageHTML +=
                            `Usually ships in 1 to 2 business days.`;
                    else
                        stockMessageHTML +=
                            `Usually ships in 24 hours.`;
                } else if (this.selectedVariant.is_preorder) {
                    stockMessageHTML =
                        `<span class="pre-order-indicator">Pre-Order</span>` +
                        (this.selectedVariant.est_restock_date
                            ? `Shipping on ${new Date(
                                  this.selectedVariant.est_restock_date
                              ).toLocaleDateString()} - Reserve Today!`
                            : 'Reserve today to ship out as soon as available!');
                } else if (workerData) {
                    const {
                        pickupDate,
                        transitDays,
                        country,
                        isInternational,
                        isAkOrHi,
                    } = workerData;

                    const target = new Date(pickupDate);
                    const transitDaysNum =
                        typeof transitDays === 'number'
                            ? transitDays
                            : null;

                    const isCanada =
                        country === 'CA' || isInternational === true;
                    const isAkOrHiDestination = isAkOrHi === true;

                    const isToday =
                        target.toLocaleDateString() ===
                        new Date().toLocaleDateString();

                    if (isToday && target > new Date()) {
                        this.startCountdown(target);
                    } else {
                        const dateDisplay =
                            target.toLocaleDateString(undefined, {
                                weekday: 'long',
                                month: 'long',
                                day: 'numeric',
                            });
                        stockMessageHTML =
                            `<span class="in-stock-indicator">In Stock</span>` +
                            `Order now! Ships on <strong>${dateDisplay}</strong>.`;
                    }

                    if (isCanada || isAkOrHiDestination) {
                        freeDeliveryMessageHTML =
                            `Shipping, taxes, duties and fees calculated in checkout`;
                    } else if (
                        !this.selectedVariant.ships_freight &&
                        transitDaysNum !== null &&
                        transitDaysNum <= 3
                    ) {
                        const dayText =
                            transitDaysNum === 1
                                ? 'Next'
                                : transitDaysNum === 2
                                ? '2'
                                : '3';
                        freeDeliveryMessageHTML =
                            `Free ${dayText} Day Delivery` +
                            `${
                                this.selectedVariant.price < 45
                                    ? ' on orders over $45'
                                    : ''
                            }`;
                    }
                }
            }

            if (stockMessageEl && stockMessageHTML) {
                stockMessageEl.innerHTML = stockMessageHTML;
            }

            if (freeDeliveryMessageEl && freeDeliveryMessageHTML) {
                freeDeliveryMessageEl.innerHTML =
                    freeDeliveryMessageHTML;
                const zip = localStorage.getItem('syl_user_zip');
                if (zip) {
                    freeDeliveryMessageEl.innerHTML +=
                        ` to <span data-action="vdm-change-zip">${zip}</span>`;
                }
            }
        } catch (e) {
            console.error(
                '[variant-delivery-messaging] Error:',
                e
            );
        }
    }

    static startCountdown(targetDate) {
        const stockMessageEl = document.getElementById(
            'variant-delivery-messaging__stock_message'
        );
        if (!stockMessageEl) return;

        const updateCountdown = () => {
            const diffMs = targetDate - new Date();

            if (diffMs <= 0) {
                clearInterval(this.countdownInterval);
                this.countdownInterval = null;
                stockMessageEl.innerHTML =
                    '<span class="in-stock-indicator">In Stock</span>Usually ships in 24 hours.';
                return;
            }

            const diffSecs = Math.floor(diffMs / 1000);
            const diffMins = Math.floor(diffSecs / 60);
            const diffHours = Math.floor(diffMins / 60);

            const hours = diffHours % 24;
            const minutes = diffMins % 60;
            const seconds = diffSecs % 60;

            let html =
                '<span class="in-stock-indicator">In Stock</span>';
            html +=
                'Want it shipped <span class="today">today</span>? Order within ';

            if (hours)
                html += `<span class="countdown">${hours} hour${
                    hours !== 1 ? 's' : ''
                }</span> `;
            if (minutes)
                html += `<span class="countdown">${minutes} minute${
                    minutes !== 1 ? 's' : ''
                }</span> `;
            if (seconds && !hours)
                html += `<span class="countdown">${seconds} second${
                    seconds !== 1 ? 's' : ''
                }</span>`;

            stockMessageEl.innerHTML = html;
        };

        updateCountdown();
        this.countdownInterval = setInterval(updateCountdown, 1000);
    }
}

await VariantDeliveryMessaging.init();
/* CUSTOM:END VariantDeliveryMessaging */
